// === Настраиваемые переменные бренда ===
export const BRAND = {
  name: "Гипнотерапия с Альфирой",
  tagline: "Мягкая, научно-обоснованная помощь для устойчивых перемен",
  phone: "+49 (0) 7641 953 7645",
  email: "alphavita@gmx.de",
  address: "Hebelstr. 27, 79312 Emmendingen, Germany",
  calendly: "https://calendly.com/alphavita-hypnotherapy/intro",
  whatsapp: "https://api.whatsapp.com/send/?phone=4915172214348&text&type=phone_number&app_absent=0",
  website: "https://hypnoanna.com",
  social: {
    instagram: "https://www.instagram.com/dubistfrei_hypnose",
    facebook: "https://www.facebook.com/people/Alphavita-Praxis-für-Coaching-Hypnose/100092349235672",
    whatsapp: "https://api.whatsapp.com/send/?phone=4915172214348&text&type=phone_number&app_absent=0"
  }
};

export const nav = [
  { href: "/", label: "Главная" },
  { href: "/process", label: "Процесс" },
  { href: "/courses", label: "Курсы" },
  { href: "/blog", label: "Блог" },
  { href: "/contact", label: "Контакты" },
];

// Экспорт services для компонента Services.jsx
export const services = [
  {
    title: "1 сеанс",
    price: "€320",
    desc: "\"Знакомство с методом\". Это идеальный вариант для тех, кто хочет понять, что такое системный подход и подходит ли для него этот вариант. Идеально для ответов на вопросы Почему и Откуда. Найти причины.",
    bullets: [
      "Первичная консультация",
      "Диагностика проблемы",
      "Первая гипнотерапевтическая сессия",
      "Рекомендации для дома",
      "Без обратной связи"
    ],
    popular: false
  },
  {
    title: "Пакет «Глубокая трансформация»",
    price: "€1000",
    desc: "Ваш персональный путь к свободе от ограничений. Работаем с причиной, а не с симптомами, чтобы вы раз и навсегда изменили свою жизнь. **5 сессий за €1000! Сессия всего 200 €.**",
    bullets: [
      "Бесплатная консультация: Первая встреча для знакомства и определения вашего запроса",
      "Диагностика и оценка: Мы вместе находим корень ваших проблем, чтобы точно знать, куда двигаться",
      "Комплексная проработка: На всех 5 сессиях мы используем индивидуально подобранные методы, такие как гипноз, коучинг и другие техники, чтобы работать с вашим запросом на глубинном уровне",
      "Персональные рекомендации: Вы получите четкий план действий, разработанный специально для вас",
      "Поддержка между сессиями: Я всегда на связи, чтобы помочь и поддержать вас в процессе изменений",
      "Дополнительные ресурсы: Инструменты и материалы, которые помогут вам закрепить результат и двигаться вперед"
    ],
    popular: false,
  },
  {
    title: "Для студентов, детей и получателей пособий",
    price: "€150",
    desc: "Специальное предложение для студентов, детей, инвалидов и получателей пособий с приложением документов.",
    bullets: [
      "Полная сессия",
      "Диагностика проблемы",
      "Гипнотерапевтическая работа",
      "Рекомендации для дома"
    ],
    popular: false
  }
];

export const pricingPlans = [
  {
    title: "1 сеанс",
    duration: "60-90 мин",
    price: "€320",
    originalPrice: null,
    savings: null,
    popular: false,
    features: [
      "Первичная консультация",
      "Диагностика проблемы",
      "Первая гипнотерапевтическая сессия",
      "Рекомендации для дома"
    ],
    bonus: null
  },
  {
    title: "По 4 сеанса",
    duration: "60-90 мин",
    price: "€1000",
    originalPrice: "€1280",
    savings: "€280",
    popular: false,
    features: [
      "4 полные сессии",
      "Глубокий анализ проблем",
      "Персональная стратегия",
      "Аудио-материалы для дома",
      "Поддержка в WhatsApp",
      "Дополнительные техники"
    ],
    bonus: "+1 сеанс в подарок"
  },
  {
    title: "Для студентов, детей и получателей пособий",
    duration: "60-90 мин",
    price: "€150",
    originalPrice: null,
    savings: null,
    popular: false,
    special: true,
    features: [
      "Полная сессия",
      "Диагностика проблемы",
      "Гипнотерапевтическая работа",
      "Рекомендации для дома"
    ],
    bonus: null
  }
];

export const reviews = [
  {
    name: "Марина",
    text: "После 4 сессий перестала заедать стресс. Появился спокойный сон и силы на спорт.",
    rating: 5,
    verified: true
  },
  {
    name: "Артём",
    text: "Анна помогла подготовиться к публичному выступлению — без паники и с уверенностью.",
    rating: 5,
    verified: true
  },
  {
    name: "Ольга",
    text: "Тревога заметно снизилась, научилась быстро возвращаться в ресурс через практики.",
    rating: 5,
    verified: true
  },
];

export const faq = [
  {
    q: "Это безопасно?",
    a: "Да. Гипнотерапия — это состояние фокусированного внимания. Вы в сознании и контролируете процесс."
  },
  {
    q: "Сколько нужно сессий?",
    a: "Часто достаточно 3–6 встреч под конкретный запрос. На вводной консультации составим план."
  },
  {
    q: "Работаете онлайн?",
    a: "Да, через Zoom/Meet. Важно обеспечить тихое пространство и гарнитуру."
  },
  {
    q: "Есть ли противопоказания?",
    a: "Есть. Мы их обсуждаем заранее: острые состояния, некоторые диагнозы — по согласованию с врачом."
  },
  {
    q: "Как подготовиться к сессии?",
    a: "Выделите 75–90 минут без отвлечений, приготовьте наушники и воду. После сессии — 10 минут на спокойную интеграцию."
  },
  {
    q: "Какие результаты ожидать?",
    a: "Результаты индивидуальны. Обычно клиенты замечают улучшения уже после 2-3 сессий."
  }
];
